import React from 'react';
import {StarIcon} from "@heroicons/react/solid";
import colors from 'tailwindcss/colors'

type Props = {
    score: number
    noOfStars?: number
}

function FeedbackStars(props: Props) {
    return (
      <div className="flex">
          {[...new Array(props.noOfStars)].map(((star, index) => (
            <StarIcon color={(props.score >= index + 1) ? colors.yellow[500] : colors.gray[300]} key={index} className="w-5" />
          )))}
      </div>
    )
}

FeedbackStars.defaultProps = {
    noOfStars: 5,
}

export default FeedbackStars;